<template>
  <button>
    <span>{{ text }}</span>
  </button>
</template>

<script>
  export default {
    name: "GuestButton",
    props: {
      text: String,
    },
  };
</script>

<style lang="scss" scoped>
  button {
    cursor: pointer;
    border-radius: 54px;
    border: 1px solid var(--black);
    background: var(--white);
    width: 40px;
    height: 40px;
    

    display: grid;
    place-items: center;
    color: var(--black);

    span {

      text-align: center;

      font-family: "proxima-nova", sans-serif;
      font-size: 16px;
      font-weight: 700;
      text-transform: uppercase;
      line-height: 0;
    }

    @media (hover:hover) {
        &:hover {
          background: var(--green);
          color: var(--white);
        }
      }

    &.selected {
      background: var(--green);
      color: var(--white);
    }
  }
</style>